import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import { FlaskConical, Calendar } from "lucide-react";

const ViewLabTests = () => {
  const { setAlert, setMessage, setSessionTimeout } = useContext(languageContext);
  const [labTests, setLabTests] = useState([]);
  const location = useLocation();

  const fetchLabTests = async () => {
    const student_id = location.state?.student_id;
    if (!student_id) return;

    try {
      const response = await axios.post(
        `https://www.careplus.gopillz.com/admin_lab_book_details`,
        JSON.stringify({ id: student_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setLabTests(response.data.data || []);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Failed to fetch lab tests. Try again later.");
        console.error(error);
      }
    }
  };

  useEffect(() => {
    fetchLabTests();
  }, []);

  const formatStatus = (status) => {
    if (status === "1") return { text: "🟡 Proposed", className: "bg-yellow-100 text-yellow-800" };
    if (status === "2" || status === "confirmed")
      return { text: "🟢 Confirmed", className: "bg-green-100 text-green-700" };
    return { text: "⚪ Unknown", className: "bg-gray-200 text-gray-700" };
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-emerald-50 to-green-100">
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 pt-24 pb-16">
        <div className="bg-white rounded-3xl shadow-xl p-8 border border-emerald-200">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-3xl font-bold text-emerald-900">
              🧪 Admin Panel – Lab Test Records
            </h2>
            <span className="text-sm bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full">
              Total Tests: {labTests.length}
            </span>
          </div>

          {labTests.length === 0 ? (
            <div className="text-center text-gray-500 italic py-16">
              No lab test records found for this student.
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {labTests.map((test) => {
                const { text, className } = formatStatus(test.status);
                return (
                  <div
                    key={test.id}
                    className="bg-white border border-emerald-200 rounded-xl p-5 shadow hover:shadow-lg transition"
                  >
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="text-lg font-semibold text-emerald-800">
                          <FlaskConical className="inline-block w-5 h-5 mr-2 text-emerald-600" />
                          {test.test_name}
                        </h3>
                      </div>
                      <span className={`text-xs px-3 py-1 rounded-full font-medium ${className}`}>
                        {text}
                      </span>
                    </div>

                    <div className="text-sm text-gray-600 flex items-center mt-2">
                      <Calendar className="w-4 h-4 mr-2 text-emerald-500" />
                      <span>{new Date(test.date).toLocaleDateString()}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewLabTests;
